<template>
  <div class="projectCalendarList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          筛选：
          <el-select v-model="maintainType" placeholder="请选择报事分类">
            <el-option key="0" label="全部分类" value="0"></el-option>
            <el-option v-for="item in maintainTypesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="commit()">{{commitname}}</el-button>
      </el-form>
    </div>
    <el-card>
      <!-- <vue-event-calendar :events="events" @day-changed="handleDayChanged"
      @month-changed="handleMonthChanged"></vue-event-calendar> -->
      <full-calendar
        ref="calendar"
        :config="config"
        :events="events"
        @event-selected="eventClick"
        @day-click="dayClick"
        @moreClick="seeMore">
      </full-calendar>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:projectCalendarList
 *@Description:项目日历
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-02-25
 */
import 'fullcalendar/dist/fullcalendar.css'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      maintainTypesList: [],
      maintainType: '0',
      commitname: require('@/config/enum').commitname,
      config: {
        firstDay: '0', // 以周日为每周的第一天
        defaultView: 'month', // 默认以月显示
        height: 678,
        fixedWeekCount: false,
        aspectRatio: 1.35, // 设置日历单元格宽度与高度的比例
        handleWindowResize: true, // 是否随浏览器窗口大小变化而自动变化
        eventLimit: true, // 数据条数太多时，限制各自里显示的数据条数（多余的以“+2more”格式显示），默认false不限制,支持输入数字设定固定的显示条数
        eventLimitText: '更多', // 当一块区域内容太多以"+2 more"格式显示时，这个more的名称自定义（应该与eventLimit: true一并用）
        // dayPopoverFormat: 'YYYY年M月d日', // 点开"+2 more"弹出的小窗口标题，与eventLimitClick可以结合用
        allDaySlot: false,
        header: { // 表头信息
          left: 'prev, next, today',
          center: 'title',
          right: 'month, agendaWeek, agendaDay, listMonth'
        },
        locale: 'zh-cn', // 语言
        buttonText: {
          today: '今天',
          month: '月',
          agendaWeek: '周',
          agendaDay: '日',
          listMonth: '日程'
        }
      },
      events: [],
    }
  },
  created() {
    this.maintainTypes()
    this.patrolList()
  },
  computed: {
    ...mapGetters({ gardenId: 'gardenId' })
  },
  methods: {
    // 报事类型下拉
    maintainTypes() {
      let loading = this.$loading()
      this.$get(`/maintainTypes?type=1&pageSize=999&pageNo=1&parentId=${this.gardenId}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.maintainTypesList = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取日历内容
    patrolList() {
      let loading = this.$loading()
      this.$get(`/patrol?gardenId=${this.gardenId}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.events = res.eventsJsonArray
            for (let i = 0; i < this.events.length; i++) {
              this.events[i].url = this.events[i].url.replace(/^.*\?/, '/#/manage/editTask?flag=true&')
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    eventRender(event, jsEvent, view) {
      console.log(event)
      console.log(jsEvent)
      console.log(view)
    },
    eventClick(event) {
      let route = event.url
      let oneList = route.split('?id=')
      let routeId = oneList[1].split('&')
      console.log(routeId[0])
      let twoList = route.split('&isPatrol=')
      console.log(twoList[1])
      // 跳转到任务管理详情页
      this.$router.push({ name: 'editTask', query: { flag: true, id: routeId[0], isPatrol: twoList[1] } })
    },
    // 筛选报事分类
    commit() {
      let loading = this.$loading()
      this.$get(`/patrol?gardenId=${this.gardenId}&TypeId1=${this.maintainType}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            for (let i = 0; i < res.eventsJsonArray.length; i++) {
              res.eventsJsonArray[i].url = res.eventsJsonArray[i].url.replace(/^.*\?/, '/#/manage/editTask?flag=true&')
            }
            this.events = res.eventsJsonArray
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击天
    dayClick() {
      console.log('点击天')
    },
    // 日历中查看更多
    seeMore() {
      console.log('点击更多')
    }
  }
}
</script>

<style lang="scss">
  .fc-widget-content{
    height: 400px !important;
    overflow: auto !important;
  }
  .fc-basic-view .fc-body .fc-row{
    height: 120.5px !important;
    overflow: hidden !important;
  }
  .fc-more-popover{
    top: 0 !important;
  }
</style>